export const AuthSignupFormControlName = {
  FirstName: 'firstName',
  LastName: 'lastName',
  Email: 'email',
  Password: 'password',
};

export default {
  AuthSignupFormControlName,
};
